import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {
  ApiResponseModel,
  ApiVisa,
  BaseApiTemplateService,
  Core2Config,
} from "../../shared";
import { InvCurrentLocationStockBalanceContainerModel } from "../../../../../../models/aggregates/erp/multipo/index";
import { CurrentLocationStockBalanceMaxMinQtyDtoModel } from "../../../data-transfer-objects/current-stock-balance-min-max-qty-dto.model";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class InvCurrentLocationStockBalanceService extends BaseApiTemplateService<InvCurrentLocationStockBalanceContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.INV_PREFIX +
      "inv-stock/current";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.INV_PREFIX +
      "inv-stock/current";
    this.httpClient = http;
  }

  public updateMinMaxQty(
    dtoObject: CurrentLocationStockBalanceMaxMinQtyDtoModel,
    visa: ApiVisa
  ): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url =
        visa.api_domain_url +
        this.endpoint_path +
        "/update-min-max-qty/backoffice-ep";
    }
    return this.httpClient.put<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
